(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["17s-cinematic-work"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-cw-use]');
    if (!link) return;
    const select = link.closest('[data-cinematic-page]')?.querySelector('#cw-interest');
    if (!select) return;
    select.value = link.dataset.cwUse;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    requestAnimationFrame(() => select.focus({ preventScroll: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["17s-personalized-video"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-pv-use]');
    if (!link) return;
    const page = link.closest('[data-personalized-page]');
    const select = page?.querySelector('select[name="contact[Use case]"]');
    if (!select) return;
    select.value = link.dataset.pvUse;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    requestAnimationFrame(() => select.focus({ preventScroll: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["17s-world-builder-creative"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-world-builder]');
    if (!root) return;

    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-inquiry]');
      if (!link) return;

      const interest = root.querySelector('#wbc-interest');
      if (!interest) return;

      interest.value = link.dataset.inquiry;
      interest.dispatchEvent(new Event('change', { bubbles: true }));
      requestAnimationFrame(() => interest.focus({ preventScroll: true }));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["17s-world-builder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-world-builder]');
    if (!root || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !window.matchMedia('(pointer: fine)').matches) return;
    root.addEventListener('pointermove', (event) => {
      const rect = root.getBoundingClientRect();
      root.style.setProperty('--wb-parallax-x', `${((event.clientX - rect.left) / rect.width - .5) * 18}px`);
      root.style.setProperty('--wb-parallax-y', `${((event.clientY - rect.top) / Math.min(rect.height, window.innerHeight) - .5) * 18}px`);
    });
    root.addEventListener('pointerleave', () => {
      root.style.setProperty('--wb-parallax-x', '0px');
      root.style.setProperty('--wb-parallax-y', '0px');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
